"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const remove_brackets_1 = require("./maps/remove_brackets");
const token_pattern_1 = require("./patterns/token_pattern");
const even_odd_split_1 = require("./utilities/even_odd_split");
const url_transformer_1 = require("./utilities/url_transformer");
exports.urlRedirectDecoder = (leftBracket, rightBracket) => url_transformer_1.default(even_odd_split_1.evenOddSplit(decodeURIComponent, remove_brackets_1.default(leftBracket, rightBracket)))(token_pattern_1.default(leftBracket, rightBracket));
exports.default = exports.urlRedirectDecoder;
//# sourceMappingURL=url_redirect_decoder.js.map